module.exports = ".tree-icon i{padding:8px}.conditions label{width:100%;margin:0px 15px}@media (max-width: 992px){.form-row{margin-top:0}}\n"